<div class="container-block">
  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline">
      <app-position-in-config
        [elementChoosing]="blockChoosing"
        [device]="device"
      ></app-position-in-config>

      <app-width-height-config
        [device]="device"
        [elementChoosing]="blockChoosing"
        [elementType]="'block'"
        [width]="position['width']"
        [height]="position['height']"
        (changeWidthHeight)="changeWidthHeight($event)"
      ></app-width-height-config>
      <li
        nz-submenu
        nzTitle="{{ 'thong_so_co_ban' | translate }}"
        [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="main-config">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
            [device]="device"
            [elementChoosing]="blockChoosing"
            [isBlock]="true"
          ></app-hide-show-config>

          <!-- Option màu nền cho frame -->
          <app-background-image-config
            [hasConfigGroup]="true"
            [configFieldName]="'block-header'"
            [elementChoosing]="blockChoosing"
            [config]="config"
            [class]="class"
            [backgroundClass]="class['block-header']"
            [backgroundConfig]="config['block-header']"
            [id_object]="blockChoosing._id"
            [isBlock]="true"
            [device]="device"
          >
          </app-background-image-config>
          <!-- Xuất hiện khi cuộn -->
          <div class="flex items-center justify-between">
            <label for="">Xuất hiện khi cuộn</label>
            <nz-switch
              [(ngModel)]="
                blockChoosing[device + '_config'].appear_when_scroll.value
              "
              (ngModelChange)="updateConfig()"
            ></nz-switch>
          </div>

          <div
            class="flex items-center"
            *ngIf="config.appear_when_scroll.value"
          >
            <label for="">{{ "khoang_cach_tu_dau_trang" | translate }}</label>
            <nz-input-number
              class="input-number"
              [nzMin]="0"
              [nzStep]="1"
              [(ngModel)]="config.appear_when_scroll.top"
              (nzBlur)="updateConfig()"
            ></nz-input-number>
          </div>
          <div
            class="mr-2 mb-4 mt-4 view-more"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 7px;
            "
            *ngIf="config['block-header'].option_background == 'color'"
          >
            <p
              class="discover_text"
              (click)="openViewAll(stylesField[2])"
              style="cursor: pointer; text-align: left; margin: 0"
            >
              {{ "mo_rong" | translate }} &#8594;
            </p>
          </div>
        </div>
      </li>

      <!-- Vị trí khi cuộn trang -->
      <div class="mt-3 mb-3">
        <div class="title mb-3" style="line-height: 1">
          {{ "vi_tri_khi_cuon_trang" | translate }}
        </div>
        <nz-select
          [(ngModel)]="config['position_onscroll']['type']"
          (ngModelChange)="updateConfig()"
        >
          <nz-option
            [nzValue]="0"
            [nzLabel]="'binh_thuong' | translate"
          ></nz-option>
          <nz-option
            [nzValue]="1"
            [nzLabel]="'co_dinh_o_top' | translate"
          ></nz-option>
        </nz-select>
        <!-- <div *ngIf="config['position_onscroll']['type'] != '0'" class="mt-4">
          <div class="title mb-1">Canh lề</div>
          <div class="d-flex align-items-center justify-content-between mt-3">
            <p class="mb-0">Trên</p>
            <nz-input-number [nzMin]="-100" [nzMax]="1000"
              [(ngModel)]="config['position_onscroll']['top']"
              (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
        </div> -->
      </div>

      <!-- Cấu hình filter -->
      <li *ngIf="config['block-header']?.option_background == 'image'" nz-submenu nzTitle="{{'anh_sang_va_tuong_phan'| translate}}"
      [(nzOpen)]="openMenu.menu8" (nzOpenChange)="openHandler('menu8')">
        <app-brightness-contrast-config [elementChoosing]="blockChoosing"  [device]="device" [class]="class" [config]="config"
          [filterConfig]="config['filter']" [opacityClass]="class['block-header__boundary']" [staticdata]="staticdata"
          [id_object]="blockChoosing._id" [configType]="'background-image'" [isBlock]="true">
        </app-brightness-contrast-config>
      </li>

      <!-- Cấu hình đường viền chung -->
      <li
        nz-submenu
        nzTitle="{{ 'kieu_vien' | translate }}"
        [(nzOpen)]="openMenu.menu2"
        (nzOpenChange)="openHandler('menu2')"
      >
        <app-borders-config
          [elementChoosing]="blockChoosing"
          [device]="device"
          [class]="class"
          [borderClass]="class['block-header']"
          [id_object]="blockChoosing._id"
          [isBlock]="true"
        >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border" style="float: right">
          <p class="m-0 title-border" (click)="openViewAll(stylesField[0])">
            {{ "mo_rong" | translate }} &#8594;
          </p>
        </div>
      </li>

      <!-- Canh lề -->
      <li
        nz-submenu
        nzTitle="{{ 'canh_le' | translate }}"
        [(nzOpen)]="openMenu.menu4"
        (nzOpenChange)="openHandler('menu4')"
      >
        <app-padding-config
          [objectChoosing]="blockChoosing"
          [device]="device"
          [class]="class"
          [classPadding]="class['block-header']"
          [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]"
          [isBlock]="true"
        >
        </app-padding-config>
      </li>

      <!-- Cấu hình hiệu ứng -->
      <li
        nz-submenu
        nzTitle="{{ 'hieu_ung' | translate }}"
        [(nzOpen)]="openMenu.menu5"
        (nzOpenChange)="openHandler('menu5')"
      >
        <app-choose-animations-config
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="blockChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [cursorClass]="class['block-header']"
          [effect_hover]="effect_hover"
          [customize]="customize"
          [type]="'block'"
          [isBlock]="true"
          [effectFileUsing]="'block-blank'"
        >
        </app-choose-animations-config>
        <!-- Cấu hình đổ bóng -->
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="editor-header">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{
        currentViewAll.title | translate
      }}</span>
    </div>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class['block-header']"
        [id_object]="blockChoosing._id"
        [isBlock]="true"
      >
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
      <app-animations-config
        [staticdata]="staticdata"
        [config]="config"
        [id_object]="blockChoosing._id"
        [customize]="customize"
        [device]="device"
        [isBlock]="true"
        [type]="'block'"
      >
      </app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 3">
      <div class="title-head">
        <p class="text-fill">{{ "phoi_mau" | translate }}</p>
        <label
          nz-checkbox
          [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"
        ></label>
      </div>
      <ng-container *ngIf="config['background-color']?.gradient_check">
        <div class="list-gradient">
          <button
            class="btn-gradient"
            *ngFor="
              let bgGradient of config['background-color']['gradient_arr'];
              let i = index
            "
            (click)="deleteGradient(i)"
            [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color'].gradient_check"
          >
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{ "them_mau" | translate }}</p>
        <div class="container_add-gradient">
          <input
            class="input-color"
            [cpOKButton]="true"
            [(colorPicker)]="config['background-color']['background']"
            type="button"
            [disabled]="!config['background-color'].gradient_check"
            [style.background]="config['background-color']['background']"
            (colorPickerClose)="addGradient($event)"
          />
        </div>
        <p class="title-head">{{ "huong_phoi_mau" | translate }}</p>
        <button
          class="gradient-direction"
          *ngFor="let type of typeGradient"
          nz-tooltip
          nzTooltipTitle="{{ type.name | translate }}"
          (click)="chooseOption(type, $event)"
          [disabled]="!config['background-color'].gradient_check"
          [style.background]="
            'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
          "
        ></button>
      </ng-container>
    </div>
  </div>
</div>
